import { IconButton, Stack, SvgIcon, Tooltip } from "@mui/material";
import { ReactComponent as IconZoomIn } from "../../../images/zoom-in.svg";
import { ReactComponent as IconZoomOut } from "../../../images/zoom-out.svg";
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';
import ZoomIndicator from "./ZoomIndicator";
import { useCallback, useEffect, useRef, useState } from "react";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { ZOOM_MAX_RATIO, ZOOM_WHEEL_STEP } from "../Cropper/react-cropper/const";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";

const buttons = [
  {
    title: "Ingrandisci",
    dataZoom: 1,
    icon: <SvgIcon component={IconZoomIn} inheritViewBox />,
  },
  {
    title: "Riduci",
    dataZoom: -1,
    icon: <SvgIcon component={IconZoomOut} inheritViewBox />,
  },
  {
    title: "Minimo",
    dataZoom: 0,
    icon: <ZoomInMapIcon />,
  },
];

const isTouchDevice = () => {
  return 'ontouchstart' in window.document.documentElement;
}

function ZoomControl() {
  const { preset } = useCropperStore();
  const {dispatch: dispatchCropperAction, action: currentCropperAction} = useCropperAction();
  const cropper = useCropperStore(s => s.getCropper());
  const cropperReady = useCropperStore(s => s.isCropperReady());
  const [zoom_, setZoom_] = useState(preset.zoom);

  useEffect(() => {
    if (cropper) {
      const handleUserZoom = (e) => {
        // console.log('handlezoom', e.type);
        setZoom_(cropper._getZoomFactor());
      };
      const event = isTouchDevice() ? 'touchmove' : 'wheel';
      cropper.cropper.addEventListener(event, handleUserZoom);
      return () => {
        cropper.cropper.removeEventListener(event, handleUserZoom);
      }
    }
  }, [cropper]);

  useEffect(() => {
    if (cropper && cropperReady) {
      setZoom_(cropper._getZoomFactor());
    }
  }, [cropper, cropperReady, currentCropperAction, preset]);

  const adjustZoom = event => {
    const pivot = cropper._getContainerCenterPivot();
    const dataZoom = Number(event.currentTarget.dataset.zoom);
    if (dataZoom === 0) {
      const value = cropper._getMinZoomRatio();
      dispatchCropperAction({ _zoomRaw: { value, pivot }});
    } else {
      // const value = dataZoom * ZOOM_WHEEL_STEP;
      const value = cropper._getZoomFactor() + (dataZoom * ZOOM_WHEEL_STEP);
      dispatchCropperAction({ _zoomRaw: { value, pivot }});
    }
  };

  const setZoomManually = e => {
    console.log('setZoomManually', e);
  };

  const getButtonDisabledStatus = useCallback((index) => {
    if (cropper) {
      const dataZoom = Number(buttons[index].dataZoom);
      switch(dataZoom) {
        case 1:
          return zoom_ >= ZOOM_MAX_RATIO;
        case -1:
        case 0:
          return (cropper.canvas.clientWidth <= cropper.face.clientWidth)
            || (cropper.canvas.clientHeight <= cropper.face.clientHeight);
        default:
          return false;
      }
    }
    return true;
  }, [cropper, zoom_]);

  return (
    <Stack direction={'row'} gap={0.5} alignItems={'center'}>
      <ZoomIndicator zoom={zoom_} onChange={setZoomManually}/>
      {buttons.map(({ title, dataZoom, icon }, index) => (
        <Tooltip key={index} placement="top" title={title}>
          <span>
            <IconButton 
              onClick={adjustZoom}
              data-zoom={dataZoom}
              size="small"
              disabled={getButtonDisabledStatus(index)}
            >
              {icon}
            </IconButton>
          </span>
        </Tooltip>
      ))}
    </Stack>
  );
};

export default ZoomControl;